import logoCorreios from "assets/icons/correiosPositive.svg";
import logoCNP from "assets/icons/logo-cnp-cap.svg";

import * as S from "./Header.style";
import { Link, useLocation } from "react-router-dom";
import StepBar from "components/Header/StepBar";
import { Divider } from "@ds/react";
import Section from "components/Section";
import Content from "components/Content";
import { getEnvVar } from "utils/environment";

const ETAPAS = {
  "/unico": 1,
  "/unico/resumo": 2,
  "/unico/dados-pessoais": 3,
  "/unico/pagamento": 4,
};

const Header = () => {
  const { pathname } = useLocation();
  const maintenanceIsOn = getEnvVar('MAINTENANCE').toLowerCase() === "on"
  return (
    <S.Header>
      <Section noPadding fullWidth>
        <S.HeaderContent>
          <Content>
            <Link to="/unico">
              <S.Icons>
                <img src={logoCNP} width={150} height={48} alt="logo CNP" />
                <img src={logoCorreios} height={24} alt="logo cap vencedor" />
              </S.Icons>
            </Link>
          </Content>
        </S.HeaderContent>
        <Divider />
        {!maintenanceIsOn && (
          <Content>
            <StepBar currentStep={ETAPAS[pathname]} />
          </Content>
        )}
      </Section>
    </S.Header>
  );
};

export default Header;
